import { $, _ } from "js/vendor";
import { getStaticUrl } from "js/config";
import { app } from "js/namespaces";
import { ds } from "js/core/models/dataService";
import * as geom from "js/core/utilities/geom";
import {
    SideBarCanvasModifier, ContentBlockType,
    ElementTextBlockPositionType, TrayType, HeaderPositionType, AssetType, NodeType
} from "common/constants";
import EditorManager from "js/editor/elementUI/EditorManager";
import { SideBar } from "js/editor/ui";
import { Convert } from "js/core/utilities/geom";
import { trackActivity } from "js/core/utilities/utilities";
import { TextElement } from "js/elements/base/TextElement";

export const AddAnnotationPanel = SideBar.extend({
    className: "editor_menu add-annotation-panel",

    closeOnCanvasClick: true,
    preventCanvasEditingWhenOpen: true,
    showHeader: false,
    type: "add-annotation-panel",
    verticalGapOffset: 20,
    lockSlide: true,

    // getPanelHeight: function() {
    //     return 110;
    // },

    getCanvasModifier: function() {
        return SideBarCanvasModifier.SCALE;
    },

    getTitle: function() {
        return null;
    },

    setup: function(options) {
        this.container = options.container || app.currentCanvas.layouter.elements.annotations;
    },

    renderContents: function($contents) {
        $contents.empty();

        this.$dragMessage = $.div("drag-label", "Drag to add");
        this.$el.prepend(this.$dragMessage);

        let allowedNodeTypes = this.container.getAllowedNodeTypes();
        if (allowedNodeTypes.contains(NodeType.BOX)) {
            this.addType({
                label: "Box",
                value: NodeType.BOX,
                image: getStaticUrl("/images/ui/node_types/node_box.svg")
            });
        }
        if (allowedNodeTypes.contains(NodeType.CIRCLE)) {
            this.addType({
                label: "Circle",
                value: NodeType.CIRCLE,
                image: getStaticUrl("/images/ui/node_types/node_circle.svg")
            });
        }
        if (allowedNodeTypes.contains(NodeType.DIAMOND)) {
            this.addType({
                label: "Diamond",
                value: NodeType.DIAMOND,
                image: getStaticUrl("/images/ui/node_types/node_diamond.svg")
            });
        }
        if (allowedNodeTypes.contains(NodeType.CAPSULE)) {
            this.addType({
                label: "Capsule",
                value: NodeType.CAPSULE,
                image: getStaticUrl("/images/ui/node_types/node_capsule.svg")
            });
        }
        if (allowedNodeTypes.contains(NodeType.TEXT)) {
            this.addType({
                label: "Text",
                value: NodeType.TEXT,
                image: getStaticUrl("/images/ui/node_types/node_text.svg")
            });
        }
        if (allowedNodeTypes.contains(NodeType.CONTENT_AND_TEXT)) {
            this.addType({
                label: "Icon & Text",
                value: NodeType.CONTENT_AND_TEXT,
                image: getStaticUrl("/images/ui/node_types/node_content_and_text.svg")
            });
        }
        if (allowedNodeTypes.contains(NodeType.BULLET_TEXT)) {
            this.addType({
                label: "Bullet",
                value: NodeType.BULLET_TEXT,
                image: getStaticUrl("/images/ui/node_types/node_bullet_text.svg")
            });
        }
        if (allowedNodeTypes.contains(NodeType.NUMBERED_TEXT)) {
            this.addType({
                label: "Numbered",
                value: NodeType.NUMBERED_TEXT,
                image: getStaticUrl("/images/ui/node_types/node_numbered_text.svg")
            });
        }
        if (allowedNodeTypes.contains(NodeType.CONTENT)) {
            this.addType({
                label: "Image/Icon",
                value: NodeType.CONTENT,
                image: getStaticUrl("/images/ui/node_types/node_content.svg")
            });
        }
        if (allowedNodeTypes.contains(NodeType.LINE)) {
            this.addType({
                label: "Line",
                value: NodeType.LINE,
                image: getStaticUrl("/images/ui/node_types/node_line.svg")
            });
        }
    },

    addType: function({ label, value, image }) {
        let $thumbnail = $.div(`annotation-type`);
        $thumbnail.append($.img(image));
        // $thumbnail.append($.div("frame"));
        $thumbnail.append($.label(label));
        this.$contents.append($thumbnail);

        $thumbnail.on("click, dblclick", event => {
            this.flashDragMessage();
        });

        $thumbnail.draggable({
            helper: () => {
                return $.div("drag-annotation-helper").append($.img(image));
            },
            appendTo: "body",
            zIndex: 99999,
            cursorAt: { left: 50 },
            start: () => {
                if (this.container.overlay) {
                    this.$dropTarget = $("body").addEl($.div("ui_widget drop_target"));
                    this.$dropTarget.setBounds(geom.Rect.FromBBox(this.container.overlay.el.getBoundingClientRect()));
                }
            },
            stop: (event, ui) => {
                if (this.$dropTarget) {
                    this.$dropTarget.remove();
                    this.$dropTarget = null;
                }

                let pt = Convert.ScreenToElementCoordinates(app.currentCanvas, this.container, event.pageX, event.pageY);

                if (pt.x < 0 || pt.x > this.container.bounds.width || pt.y < 0 || pt.y > this.container.bounds.height) {
                    this.close();
                    return;
                }

                let x = pt.x / this.container.bounds.width;
                let y = pt.y / this.container.bounds.height;

                const props = {
                    "slide_id": app.currentCanvas.dataModel.id,
                    "template_id": app.currentCanvas.slideTemplate.constructor.id,
                    "template_title": app.currentCanvas.slideTemplate.constructor.title,
                    "element_type": value
                };
                trackActivity("Slide", "ElementAdded", null, null, props);

                if (value == NodeType.LINE) {
                    let connector = this.container.connectors.addItem({
                        sourcePoint: pt,
                        targetPoint: pt.offset(200, 0),
                        connectorType: "straight"
                    });
                    app.currentCanvas.updateCanvasModel().then(() => {
                        ds.selection.element = this.container.connectors.getItemElementById(connector.id);
                    });
                } else {
                    let annotation = this.container.addItem({
                        nodeType: value, x, y,
                        // blocks: [{ type: ContentBlockType.TITLE }]
                    });
                    app.currentCanvas.updateCanvasModel().then(() => {
                        const newNode = this.container.getItemElementById(annotation.id);
                        const children = newNode.findChildElements(TextElement);
                        const textChild = children?.[children.length - 1];
                        const selectedElement = textChild || newNode;
                        ds.selection.element = selectedElement;
                    });
                }

                this.close();
            }
        });
    },

    flashDragMessage: function() {
        this.$dragMessage.velocity("callout.flash");
    }

});
